import {
    PredefinedCommentFormModel,
    PredefinedCommentFormValidity,
} from './settings-devices-predefined-comments-form.model';
import { ErrorMapping } from 'core/types/error-mapping';
import type { PocInputValidity } from 'commons/types';

export const initialPredefinedCommentFormModel: PredefinedCommentFormModel = {
    commentText: '',
    active: true,
    deviceTypeEntries: [
        {
            id: crypto.randomUUID(),
            deviceTypeId: undefined,
            resultTypes: [],
            erroneous: false,
            locations: [],
            order: null,
        },
    ],
};

export const COMMENT_PRIORITY_MIN = 1;
export const COMMENT_PRIORITY_MAX = 99999;

export const PREDEFINED_COMMENT_FORM_ERROR_MAPPINGS: ErrorMapping<string, keyof PredefinedCommentFormModel>[] = [
    { errorCode: 'E_POC_ADM_DM_00182', field: 'commentText', type: 'duplicated' },
];

export const initialPredefinedCommentFormValidity: PredefinedCommentFormValidity = {
    commentText: { state: 'valid' },
};

export const DEFAULT_COMMENT_LENGTH = 255;

export const MAX_COMMENT_LENGTH_WHEN_MARKED_AS_ERRONEOUS = 20;

export const COMMENT_TEXT_TOO_LONG_ERROR = { state: 'error', type: ['too-long'] } as PocInputValidity;

export const COMMENT_EMPTY_ERROR = { state: 'error', type: ['value-missing'] } as PocInputValidity;
